import { render } from "./StatsListV2.vue?vue&type=template&id=759b7440&scoped=true"
import script from "./StatsListV2.vue?vue&type=script&lang=ts"
export * from "./StatsListV2.vue?vue&type=script&lang=ts"

import "./StatsListV2.vue?vue&type=style&index=0&id=759b7440&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-759b7440"

export default script